export default __webpack_public_path__ + "static/Cooking_Pot-3e8612c5cf70c76f36e3aafafe8378c2.png";